import { useTranslations } from "@zapier/i18n";
import { Button, Spacer, Text } from "@zapier/design-system";
import styles from "./TeamsUpsell.module.css";
import { useAccountActionPermissions } from "@zapier/client";
import { useState } from "react";
import { TeamsTrialModalWrapper } from "./TeamsTrialModalWrapper";
import { TEAMS_UPSELL } from "@zapier/utils";

export function TeamsUpsell() {
  const t = useTranslations("teams-upsell");

  const [isTeamsTrialModalOpen, setIsTeamsTrialModalOpen] = useState(false);
  const { hasTrialedTeams } = useAccountActionPermissions();

  return (
    <div className={styles.root}>
      <div className={styles.textWrapper}>
        <img
          alt={t("images.teams-background-alt")}
          src={TEAMS_UPSELL}
          width={194}
          height={49}
        />
        <Spacer height={20} />
        <Text tag="p" type="SectionHeader">
          {t("headings.upgrade-or-try-teams", {
            hasTrialedTeams: hasTrialedTeams ? "true" : "false",
          })}
        </Text>
        <Spacer height={10} />
        <Text tag="p" type="Body1Multiline" color="TextWeaker">
          {t.rich("descriptions.teams-plan-benefits", {
            bold: (chunks) => <strong>{chunks}</strong>,
          })}
        </Text>
        <Spacer height={20} />
        <div className={styles.buttonWrapper}>
          <Button
            variant="secondary"
            onPress={() => setIsTeamsTrialModalOpen(true)}
          >
            {t("buttons.label", {
              hasTrialedTeams: hasTrialedTeams ? "true" : "false",
            })}
          </Button>
        </div>
      </div>
      <TeamsTrialModalWrapper
        isTeamsTrialModalOpen={isTeamsTrialModalOpen}
        closeModal={() => setIsTeamsTrialModalOpen(false)}
      />
    </div>
  );
}
